import { render, staticRenderFns } from "./QuizDuo.vue?vue&type=template&id=132a0c27&"
import script from "./QuizDuo.vue?vue&type=script&lang=js&"
export * from "./QuizDuo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports